export default "__VITE_ASSET__29a5ab0b__$_?component__"